<div class="qa-table-export">
  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
                (click)="isTableSearchCollapsed = !isTableSearchCollapsed"
                [attr.aria-expanded]="!isTableSearchCollapsed" aria-controls="questionnaire-submission-table-export-fields">
          <span class="mm-pane-toggle-label"><i class="fa fa-table" aria-hidden="true"></i><span>{{_(KEYS.TABLE_EXPORT.TABLE_EXPORT)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isTableSearchCollapsed, 'fa-chevron-up': !isTableSearchCollapsed}"></i>
          </span>
        </button>
      <div id="questionnaire-submission-table-export-fields" class="card-text" [ngbCollapse]="isTableSearchCollapsed">
        <div class="mt-2 mb-2 qa-grid-table-export">
          <div class="search-field field-span2">
            <label>{{_(KEYS.TABLE_EXPORT.QUESTIONNAIRE)}}</label>
            <app-select2
              [options]="selectOptions"
              [hideLabel]="true"
              [hideButton]="true"
              (selectedChange)="onQuestionnaireSelect($event)"
            >
              <option value="">...</option>
              <option *ngFor="let questionnaire of questionnaireTitles" value="{{questionnaire._id}}">
                {{questionnaire.title[locale]}}
              </option>
            </app-select2>
          </div>
          <div class="search-field">
            <label>{{_(KEYS.TABLE_EXPORT.OMIT_PATIENT_DATA)}}</label>
            <select class="form-control" [(ngModel)]="omitPatientData">
              <option value="0">{{_(KEYS.TABLE_EXPORT.NO)}}</option>
              <option value="1">{{_(KEYS.TABLE_EXPORT.YES)}}</option>
            </select>
          </div>
          <div class="search-field">
            <label>{{_(KEYS.TABLE_EXPORT.REV)}}</label>
            <select class="form-control" [(ngModel)]="selectedRevision">
              <option *ngFor="let revision of questionnaireRevisions" value="{{revision.revision}}">
                {{revision.revision}}
              </option>
              <option value="all" *ngIf="questionnaireRevisions && questionnaireRevisions.length">
                {{_(KEYS.TABLE_EXPORT.ALL_REVS)}}
              </option>
            </select>
          </div>
          <div class="search-field">
            <label>{{_(KEYS.TABLE_EXPORT.FROM)}}</label>
            <input
              type="text" class="form-control"
              ngbDatepicker #fromDate="ngbDatepicker"
              [(ngModel)]="selectedFromDate"
              (focus)="onFromDateFocus()"
              (dateSelect)="onFromDateSelect()"
            >
          </div>
          <div class="search-field">
            <label>{{_(KEYS.TABLE_EXPORT.TO)}}</label>
            <input
              type="text" class="form-control"
              ngbDatepicker #toDate="ngbDatepicker"
              [minDate]="toDateMin"
              [(ngModel)]="selectedToDate"
              (focus)="onToDateFocus()"
              (dateSelect)="onToDateSelect()"
            >
          </div>
          <div class="search-field export-field">
            <label>{{_(KEYS.TABLE_EXPORT.EXPORT)}}</label>
            <button
              class="btn btn-success export-btn"
              (click)="onExport()"
              [attr.disabled]="(!canExport() || exportCount <= 0) ? true : null"
            >
              <i class="fa fa-download"></i>&nbsp;
              <ng-container *ngIf="exportCount > 0">{{exportCount}} {{_(KEYS.TABLE_EXPORT.RECORDS_EXPORT)}}</ng-container>
              <ng-container *ngIf="exportCount <= 0">{{_(KEYS.TABLE_EXPORT.NO_RECORDS)}}</ng-container>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

